export default __webpack_public_path__ + "static/media/2.e119e57a.jpeg";